import React from "react";
import { Spinner, Stack } from "sprint-common-web";

import { CloudFileFilePreviewErrorBoundary } from "../../../../../content-ingestion/cloud-files/details/sections/preview/cloud-file-preview/CloudFilePreviewErrorBoundary";
import { useCloudAssetDetails } from "../../common/hooks/useCloudAssetDetails";
import { CloudAssetDetailsFilePreview } from "./preview/CloudAssetDetailsFilePreview";

export const CloudAssetPlaybackSection = (): JSX.Element => {
    const { data: assetDetails, isLoading } = useCloudAssetDetails();

    return (
        <Stack>
            <CloudFileFilePreviewErrorBoundary>
                {isLoading || !assetDetails ? (
                    <Spinner />
                ) : (
                    <CloudAssetDetailsFilePreview minHeight={520} assetDetails={assetDetails} />
                )}
            </CloudFileFilePreviewErrorBoundary>
        </Stack>
    );
};
